// react
import { useEffect, useState, Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
// mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogContentText,
  Select,
  MenuItem,
  Box,
  Typography,
  LinearProgress,
  useTheme,
  IconButton,
  Popover,
  PopoverOrigin,
} from "@mui/material";
// src
import Icon from "../Icon";
import ChevronRight from "../../../images/icons/neutral_edit/Chevron Right.svg";
import UploadFileDialog from "./UploadFile";
import UploadARFileDialog from "./UploadARFile";
import UploadGsplatFile from "./UploadGsplatFile";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { red } from "@mui/material/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { display } from "@mui/system";

type UploadProps = {
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  isARAvailable: boolean;
  setAnchorEl: Dispatch<SetStateAction<any>>;
};

const UploadFileBaseDialog = ({
  setErrorSnackbar,
  setErrorMsg,
  setOpenWarning,
  setMsgWarning,
  isARAvailable,
  setAnchorEl,
}: UploadProps) => {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [progressDialog, setProgressDialog] = useState(false);
  // Loding flag
  const [uploadResult, setUploadResult] = useState(false);
  const [uploadingCheck, setUploadingCheck] = useState(false);
  // Importボタン制御
  const [uploadingPercent, setUpLoadingPercent] = useState(0);

  const [selectType, setSelectType] = useState(isARAvailable ? 1 : 0);
  const [isShortageImageDialog, setIsShortageImageDialog] =
    useState<boolean>(false);

  useEffect(() => {
    // アップロード状態チェック
    if (uploadingPercent === 100) setUploadingCheck(true);
    else setUploadingCheck(false);
  }, [uploadingPercent]);

  useEffect(() => {
    setSelectType(isARAvailable ? 1 : 0);
  }, [isARAvailable]);

  window.addEventListener("focus", function () {
    if (!openDialog) {
      document.body.style.cssText = "";
    }
  });

  const handleShortageImageClose = () => {
    setIsShortageImageDialog(false);
  };

  const handleOpen = async () => {
    setOpenDialog(true);
    setAnchorEl(null);
    document.body.style.cssText = `position: fixed; top: -${window.scrollY}px; overflow-y: scroll; width: 100%;`;
  };

  const handleClose = () => {
    setOpenDialog(false);
    const scrollY = document.body.style.top;
    document.body.style.cssText = "";
    window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
  };

  const handleResultClose = () => {
    setUploadResult(false);
    window.location.reload();
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customMainColor = {
    background: theme.palette.primary.main,
    boxShadow: "none",
  };

  const RightIcon = () => {
    return (
      <div className="upload-img">
        <Icon imagePath={ChevronRight} color={customColor.color} />
      </div>
    );
  };

  type CustomPopoverProps = {
    anchorOrigin: PopoverOrigin;
    transformOrigin: PopoverOrigin;
    content: string;
  };
  const CustomPopover = ({
    anchorOrigin,
    transformOrigin,
    content,
  }: CustomPopoverProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const replaceNewLine = (s: String) => {
      return s.split("\n").map((line) => (
        <span>
          {line}
          <br />
        </span>
      ));
    };

    const open = Boolean(anchorEl);

    return (
      <div>
        <IconButton onClick={handleClick} style={{ padding: 0 }}>
          <FontAwesomeIcon icon={faCircleQuestion} style={customColor} />
        </IconButton>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
          style={{ bottom: 20 }}
        >
          <Typography sx={{ p: 2 }} style={{ width: "full" }}>
            {content ? replaceNewLine(content) : ""}
          </Typography>
        </Popover>
      </div>
    );
  };

  return (
    <div className="upload-div1">
      {/* <div onClick={handleOpen} className="upload-div"> */}
      <MenuItem onClick={handleOpen} className="upload-div">
        <p className="upload-p">{t("UPLOAD")}</p>
        <RightIcon />
      </MenuItem>
      {/* アップロードダイアログ */}
      <Dialog
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ id: "upload-file18" }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle className="upload-file16" style={customBackgroundStyles}>
          {t("UPLOAD")}
          <Button
            style={customColor}
            className="x-btn upload-file15"
            onClick={handleClose}
          >
            ×
          </Button>
          <div className="border-comm" />
          <div />
        </DialogTitle>
        <DialogContent
          style={{
            overflowX: "hidden",
            overflowY: "scroll",
            textAlign: "left",
            scrollbarWidth: "none",
            ...customBackgroundStyles,
          }}
        >
          {/* <FilterCombobox
            label={t("DATA_TYPE")}
            items={[]}
            value={selectType}
            setValue={setSelectType}
          />
          <SearchBox
            value={selectType}
            setValue={setSelectType}
            inputSX={{
              ".MuiOutlinedInput-notchedOutline": {
                border: `2px solid ${theme.palette.base.border}`,
              },
            }}
          /> */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <DialogContentText
              style={{ ...customColor, marginTop: "22px" }}
              className="upload-file7"
            >
              {t("DATA_TYPE")}
            </DialogContentText>
            <div style={{ display: "flex" }}>
              <Select
                value={selectType}
                onChange={(e) => setSelectType(e.target.value as number)}
                style={{ margin: "15px 0", height: "40px" }}
                sx={{
                  minWidth: "253px",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.base.border,
                    borderWidth: "2px",
                  },
                }}
              >
                {isARAvailable && (
                  <MenuItem value={1}>{t("DESIGN_DATA_IFC")}</MenuItem>
                )}
                {isARAvailable && (
                  <MenuItem value={6}>{t("DESIGN_DATA_MODEL3D")}</MenuItem>
                )}
                {isARAvailable && (
                  <MenuItem value={2}>{t("POINT_DATA_LAS")}</MenuItem>
                )}
                {isARAvailable && (
                  <MenuItem value={3}>{t("HEATMAP_DATA")}</MenuItem>
                )}
                {isARAvailable && (
                  <MenuItem value={4}>{t("HEATMAP_DATA_GEOJSON")}</MenuItem>
                )}
                <MenuItem value={0}>{t("SHOOTING_DATA_ZIP")}</MenuItem>
                {isARAvailable && (
                  <MenuItem value={5}>
                    {t("UPLOAD_GAUSSIAN_SPLATTING")}
                  </MenuItem>
                )}
              </Select>
              {(selectType == 1 ||
                selectType == 2 ||
                selectType === 3 ||
                selectType === 4 ||
                selectType === 6) && (
                <div style={{ marginLeft: "20px", marginTop: "20px" }}>
                  <CustomPopover
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    content={t("NOTE_UPLOAD_FILE")}
                  />
                </div>
              )}
            </div>
          </div>

          {selectType == 0 && (
            <UploadFileDialog
              setErrorSnackbar={setErrorSnackbar}
              setErrorMsg={setErrorMsg}
              setOpenWarning={setOpenWarning}
              setMsgWarning={setMsgWarning}
              setProgressDialog={setProgressDialog}
              setUploadResult={setUploadResult}
              setUpLoadingPercent={setUpLoadingPercent}
              setOpenDialog={setOpenDialog}
              openDialog={openDialog}
              setIsShortageImageDialog={setIsShortageImageDialog}
            />
          )}
          {[1, 2, 3, 4, 5, 6].includes(selectType) && (
            <UploadARFileDialog
              setErrorSnackbar={setErrorSnackbar}
              setErrorMsg={setErrorMsg}
              setOpenWarning={setOpenWarning}
              setMsgWarning={setMsgWarning}
              setProgressDialog={setProgressDialog}
              setUploadResult={setUploadResult}
              setUpLoadingPercent={setUpLoadingPercent}
              setOpenDialog={setOpenDialog}
              openDialog={openDialog}
              selectType={selectType}
            />
          )}
        </DialogContent>
      </Dialog>
      {/* アップロードプログレスダイアログ */}
      <Dialog
        open={progressDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: "upload-loding-page",
          style: { ...customBackgroundStyles },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        {uploadingCheck ? (
          <div className="upload-loding-comm">
            <Typography
              style={customColor}
              variant="h5"
              className="upload-loding"
            >
              {t("WAIT_LITTLE")}
            </Typography>
            <Box
              width="30%"
              mr={1}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <LinearProgress sx={{ height: "10px" }} />
            </Box>
          </div>
        ) : (
          <div className="upload-loding-comm">
            <Typography
              style={customColor}
              variant="h5"
              className="upload-loding"
            >
              {t("UPLOADING")}
            </Typography>
            <Box
              width="30%"
              mr={1}
              sx={{
                position: "absolute",
                top: "55%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <LinearProgress
                variant="determinate"
                value={uploadingPercent}
                sx={{ height: "10px" }}
              />
            </Box>
            <Typography
              variant="body2"
              color="textSecondary"
              className="upload-loding upload-loding1"
            >
              {`${uploadingPercent}%`}
            </Typography>
          </div>
        )}
      </Dialog>
      {/* アップロード完了ダイアログ */}
      <Dialog
        open={uploadResult}
        PaperProps={{
          className: "upload-finish-page",
          style: { ...customBackgroundStyles },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle style={customColor} className="upload-file21">
          {t("UPLOAD_COMPLETE")}
          <Button
            style={customColor}
            className="x-btn upload-btn"
            onClick={handleResultClose}
          >
            ×
          </Button>
          <div id="border-comm" />
        </DialogTitle>
        <DialogContentText style={customColor} id="upload-file20">
          {t("UPLOAD_COMPLETE_2")}
        </DialogContentText>
        <Button
          style={customMainColor}
          className="upload-file22"
          size="small"
          variant="contained"
          onClick={handleResultClose}
        >
          {"OK"}
        </Button>
      </Dialog>
      {/* 画像枚数不足のダイアログ */}
      <Dialog
        open={isShortageImageDialog}
        PaperProps={{
          className: "upload-finish-page",
          style: { ...customBackgroundStyles },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: customDialogBackgroundColor.color,
            },
          },
        }}
      >
        <DialogTitle style={customColor} className="upload-file21">
          {t("UPLOAD_ERROR")}
          <Button
            style={customColor}
            className="x-btn upload-btn"
            onClick={handleShortageImageClose}
          >
            ×
          </Button>
          <div id="border-comm" />
        </DialogTitle>
        <div
          style={{
            margin: 0,
            display: "flex",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningAmberIcon sx={{ color: red[500] }} />
          <DialogContentText style={customColor} id="upload-file20">
            {t("INSUFFICIENT_PHOTOS_NUMBER")}
          </DialogContentText>
        </div>
        <DialogContentText style={customColor} id="upload-file20">
          {t("TAKE_TEN_MORE_PICTURE")}
        </DialogContentText>
        <Button
          style={customMainColor}
          className="upload-file22"
          size="small"
          variant="contained"
          onClick={handleShortageImageClose}
        >
          {t("CONFIRMATION")}
        </Button>
      </Dialog>
    </div>
  );
};

export default UploadFileBaseDialog;
